import Api from '../../../Api'
import { all, call, put, takeEvery} from 'redux-saga/effects'
import { combineReducers } from "redux";
import createTableFetcher from 'common/reducer/createTableFetcher'

const getFetcher = state => state.waas.clusters.fetcher

const processClusters = (clusters) => {
    const clusters_list = [];
    let issues_dict = {};
    if(clusters){
        issues_dict = clusters['issues']
        delete clusters['issues']

        Object.keys(clusters).sort((a,b) => {
            const AhasWarnings = Object.keys(clusters[a]['warnings']).length !== 0;
            const AhasErrors = Object.keys(clusters[a]['errors']).length !== 0;
            const BhasWarnings = Object.keys(clusters[b]['warnings']).length !== 0;
            const BhasErrors = Object.keys(clusters[b]['errors']).length !== 0;
            const sameStatus = (AhasErrors && BhasErrors) ||
                (!AhasErrors && !BhasErrors && AhasWarnings && BhasWarnings) ||
                (!AhasErrors && !BhasErrors && !AhasWarnings && !BhasWarnings)
            
            if(sameStatus){
                return clusters[a]['name'].localeCompare(clusters[b]['name']); 
            }else if(AhasErrors || BhasErrors){
                return BhasErrors ? 1 : -1;
            }else{ // one has warnings
                return BhasWarnings ? 1 : -1;
            }
        }).map((c) => { 
            let RLC_list = []

            Object.keys(clusters[c]['RLCs']).sort((a,b) => {
                return a.localeCompare(b, undefined, {'numeric': true});
            }).map((r) => {
                let controller_list = []

                Object.keys(clusters[c]['RLCs'][r]['controllers']).sort((a,b) => {
                    return a.localeCompare(b);
                }).map((controller) => controller_list.push({...clusters[c]['RLCs'][r]['controllers'][controller], 'id': controller}));

                return RLC_list.push({...clusters[c]['RLCs'][r], 'id': r, 'controllers': controller_list})
            });

            return clusters_list.push({...clusters[c], 'id': c, 'RLCs': RLC_list});
        });
    }

    return {'clusters': clusters_list, 'issues': issues_dict};
};

export const fetcher = createTableFetcher('clusters', Api.fetchClusters, getFetcher, undefined, processClusters)

export const types = {
    GET_DEVICES_INFO: 'CLUSTERS/GET_DEVICES_INFO',
    SET_DEVICES_INFO: 'CLUSTERS/SET_DEVICES_INFO',
    GET_TRAFFIC_MANAGERS_INFO: 'CLUSTERS/GET_TRAFFIC_MANAGERS_INFO',
    SET_TRAFFIC_MANAGERS_INFO: 'CLUSTERS/SET_TRAFFIC_MANAGERS_INFO',
}

export const actions = {
    setDevicesInfo: (devices_info, region_id) => ({ type: types.SET_DEVICES_INFO, devices_info, region_id }),
    getDevicesInfo: (region_id) => ({ type: types.GET_DEVICES_INFO, region_id }),
    setTrafficManagersInfo: (traffic_managers_info) => ({ type: types.SET_TRAFFIC_MANAGERS_INFO, traffic_managers_info }),
    getTrafficManagersInfo: () => ({ type: types.GET_TRAFFIC_MANAGERS_INFO }),
    ...fetcher.actions
}

export const initialState = {
    devices_info: {},
    traffic_managers_info: {},
}

const clusters = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_DEVICES_INFO:
            return {
                ...state,
                devices_info: {
                    ...state.devices_info,
                    [action.region_id]: action.devices_info,
                },
            };
        case types.SET_TRAFFIC_MANAGERS_INFO:
            return {
                ...state,
                traffic_managers_info: action.traffic_managers_info,
            };            
        default:
            return state;
    }
}

export function* getDevicesInfo({ region_id }) {
    if (region_id) {
        try {
            const devices_info = yield call(Api.getDevicesInfo, region_id);
            yield put(actions.setDevicesInfo(devices_info, region_id));
        }
        catch (e) {
        }
    }
}

export function* getTrafficManagersInfo() {
    try {
        const traffic_managers_info = yield call(Api.getTrafficManagersInfo);
        yield put(actions.setTrafficManagersInfo(traffic_managers_info));
    }
    catch (e) {
    }
}

export default combineReducers({
    clusters,
    fetcher: fetcher.reducer
});

export function* clustersFlow() {
    yield takeEvery(types.GET_DEVICES_INFO, getDevicesInfo);
    yield takeEvery(types.GET_TRAFFIC_MANAGERS_INFO, getTrafficManagersInfo);

}

export function* clustersSaga() {
    yield all([
        fetcher.saga(),
        clustersFlow(),
    ])
}